module.exports = __webpack_public_path__ + "img/intrusion-systemimg-7.8d48ad28.png";